import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { callPostApi } from "../../function/ApiCallFunction";
import { consoleColors, primaryButtonSx } from "../admin/consoleTheme";
import { CASHI_TAGLINE, cashiLogo } from "../../include/cashiBrand";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const save = async (event) => {
    event.preventDefault();
    if (password.length < 4) { toast.error("Password must be at least 4 characters"); return; }
    if (password !== again) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      const result = await callPostApi("store-login", { mod: "STORE_RESET_PASSWORD", data_arr: { token, password } });
      if (result.status === "200") setDone(true);
      else toast.error(result?.status_message || result?.data?.error || "Could not update the password");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 3, background: consoleColors.page }}>
      <Box sx={{ width: "100%", maxWidth: 420, background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 3, p: 4 }}>
        <Box component="img" src={cashiLogo} alt="Cashi" sx={{ height: 36, width: "auto" }} />
        <Typography sx={{ fontSize: 14, fontWeight: 650, color: consoleColors.ink, mt: 1.4, lineHeight: 1.4 }}>{CASHI_TAGLINE}</Typography>
        <Typography sx={{ fontSize: 28, fontWeight: 700, color: consoleColors.ink, mt: 2 }}>{done ? "Password updated" : "Set a new password"}</Typography>
        {done ? (
          <>
            <Typography sx={{ color: consoleColors.muted, mt: 1.2, lineHeight: 1.5 }}>You can sign in with the new password.</Typography>
            <Button variant="contained" sx={{ ...primaryButtonSx, mt: 3 }} onClick={() => navigate("/")}>Sign in</Button>
          </>
        ) : (
          <Box component="form" onSubmit={save}>
            <Typography sx={{ color: consoleColors.muted, mt: 1, mb: 2, lineHeight: 1.5 }}>Choose a new password for this store.</Typography>
            <TextField fullWidth label="New password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} sx={{ mb: 2 }} />
            <TextField fullWidth label="Confirm password" type="password" value={again} onChange={(event) => setAgain(event.target.value)} />
            <Button type="submit" fullWidth disabled={loading || !token} variant="contained" sx={{ ...primaryButtonSx, mt: 3, py: 1.2 }}>
              {loading ? "Saving..." : "Save password"}
            </Button>
            {!token && <Typography sx={{ color: "#b45309", mt: 1.5, fontSize: 14 }}>This reset link is missing. Request a new one from sign in.</Typography>}
          </Box>
        )}
      </Box>
    </Box>
  );
}
